import { render } from "./IconRfidToken.vue?vue&type=template&id=2a130dc4"
const script = {}

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__